<div class="root" aria-hidden="true">
  <img *ngIf="avatarUrl" [src]="avatarUrl" alt="">

  <svg width="125" height="129" viewBox="0 0 125 129" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M43.4996 129L18.9946 27.2709L36.8651 13.7961L124.924 67.6037L43.4996 129Z"
      fill="url(#paint0_linear_1305_16148)" />
    <rect x="57.9766" y="33.5923" width="39.9544" height="39.9544" rx="10"
      transform="rotate(-17.7787 57.9766 33.5923)" fill="var(--bg-secondary-450)" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M76.1448 47.9191L72.7968 37.478L82.3039 40.1868L76.1448 47.9191Z" fill="var(--secondary-icon-color)" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M79.4925 58.3605L76.1445 47.9194L85.6515 50.6282L79.4925 58.3605Z" fill="var(--secondary-icon-color)" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M85.6507 50.6276L82.3027 40.1865L91.8097 42.8953L85.6507 50.6276Z" fill="var(--secondary-icon-color)" />
    <g clip-path="url(#clip0_1305_16148)">
      <path
        d="M39.7866 86.6025L40.6519 83.7089C41.1109 82.1741 40.9414 80.5198 40.1807 79.11C39.4199 77.7002 38.1303 76.6503 36.5955 76.1913L27.915 73.5954C26.3801 73.1364 24.7259 73.3059 23.316 74.0666C21.9062 74.8273 20.8563 76.117 20.3973 77.6518L19.532 80.5453"
        stroke="var(--bg-secondary-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M33.9859 69.1059C37.182 70.0617 40.5478 68.2456 41.5036 65.0495C42.4594 61.8534 40.6433 58.4877 37.4472 57.5319C34.2511 56.5761 30.8853 58.3922 29.9295 61.5883C28.9737 64.7844 30.7899 68.1501 33.9859 69.1059Z"
        stroke="var(--bg-secondary-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <path
      d="M64.0505 89.509C62.4526 89.3031 60.9752 90.5494 60.7506 92.2926L59.3273 103.34C59.1027 105.083 60.216 106.663 61.814 106.869L80.6204 109.292C82.2183 109.498 83.7001 108.218 83.9203 106.508"
      stroke="var(--secondary-icon-color)" stroke-width="2" />
    <path
      d="M69.7048 83.8923L91.83 86.7428C93.0902 86.9051 94.0965 88.1833 93.8955 89.7441L92.235 102.632C92.0339 104.193 90.7364 105.175 89.4763 105.012L67.3511 102.162C66.0909 101.999 65.0845 100.721 65.2856 99.1604L66.9461 86.2721C67.1472 84.7112 68.4447 83.7299 69.7048 83.8923Z"
      stroke="var(--secondary-icon-color)" stroke-width="2" />
    <path d="M77.2559 89.7397L76.2523 97.5294L82.9857 94.4381L77.2559 89.7397Z" fill="var(--secondary-icon-color)" />
    <defs>
      <linearGradient id="paint0_linear_1305_16148" x1="27.7121" y1="20.698" x2="75.2879" y2="83.7937"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.293252" stop-color="var(--bg)" />
        <stop offset="1" stop-color="var(--bg)" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_1305_16148">
        <rect width="36.2416" height="36.2416" fill="var(--bg)"
          transform="translate(21.3838 48) rotate(16.6494)" />
      </clipPath>
    </defs>
  </svg>
</div>
